<template>
  <div class="new-report">
    <div class="report-header">
      <!-- Added back button -->
      <div class="heads">
        <span class="btn new-content-data-item-toggle-circle" @click="goBack()">
          <span class="miv">e</span>
        </span>
        <h2 v-if="this.$route.name === 'newReport'" class="title">Нов отчет</h2>
        <h2 v-if="this.$route.name === 'editReport'" class="title">
          Редактиране на отчет
          <span v-if="report.isInvalid">
            (
            <img class="flag" src="../assets/img/flag_yes.svg" alt="Valid" />
            Грешен отчет)
          </span>
        </h2>
      </div>
      <!-- NEW REPORT BUTTONS DESKTOP-->
      <div class="btns desktop" v-if="allowSave">
        <button class="btn btn-close" @click="cancelReport()">
          <span class="miv">F</span>
          Отказ
        </button>
        <button class="btn btn-new" @click="save()">
          <span class="miv">Y</span>
          Запис
        </button>
      </div>
    </div>
    <!-- NEW REPORT CONTENT -->
    <div
      class="new-wrapper"
      :class="{ 'new-wrapper-invalid': report.isInvalid }"
    >
      <div class="new-content">
        <div class="new-content-inputs">
          <!-- ДАТА -->
          <div class="new-input-wrapper">
            <label for="newReportDate">Дата</label>
            <div class="new-input">
              <span class="miv">D</span>
              <input
                class="date"
                type="text"
                id="newReportDate"
                @click="openDropdown(0)"
                @focus="openDropdown(0)"
                @blur="closeDropdown(0)"
                placeholder="Дата"
                v-model="formatedDate"
                :disabled="this.$route.name === 'editReport'"
                readonly
              />
              <span v-if="this.$route.name === 'editReport'" class="disabled"
                >A</span
              >
            </div>
            <div
              class="new-input-dropdown datepicker-dropdown"
              :class="{ 'datepicker-dropdown-active': openedDropdown[0] }"
            >
              <datepicker
                :language="bg"
                :inline="true"
                :monday-first="true"
                :wrapper-class="'custom-datepicker'"
                :calendar-class="'custom-calendar'"
                v-model="report.date"
                @selected="
                  closeDropdown(0), reportChanged(), handleDateChange()
                "
              ></datepicker>
            </div>
          </div>
          <!-- DESKTOP COMPANY -->
          <div class="new-input-wrapper">
            <label>Фирма</label>
            <div
              class="new-input"
              :class="{
                'new-input-disabled': this.$route.name === 'editReport',
              }"
            >
              <span class="miv">Z</span>
              <!-- NOT SELECTED -->
              <input
                v-if="!report.company._id.length"
                type="text"
                placeholder="Име на фирма"
                @focus="getCompanies(), openDropdown(3)"
                @blur="closeDropdown(3)"
                v-model="searchCompanies"
                :disabled="this.$route.name === 'editReport'"
              />
              <!-- SELECTED -->
              <input
                v-else
                type="text"
                placeholder="Име на фирма"
                @focus="getCompanies(), openDropdown(3)"
                v-model="report.company.companyName"
                @blur="closeDropdown(3)"
                :disabled="
                  this.$route.name === 'editReport' || report.company._id.length
                "
              />
              <span
                v-if="
                  report.company._id.length && this.$route.name !== 'editReport'
                "
                class="clear"
                @click="resetSelectedCompany()"
                >F</span
              >
              <span v-if="this.$route.name === 'editReport'" class="disabled"
                >A</span
              >
            </div>
            <!-- DROP-DOWN COMPANIES -->
            <div
              class="new-input-dropdown"
              :class="{ 'new-input-dropdown-active': openedDropdown[3] }"
            >
              <ul v-if="companies.length">
                <li
                  v-for="c in filteredCompanies()"
                  :key="c._id"
                  @click="selectCompany(c), reportChanged()"
                >
                  {{ c.companyName }}
                </li>
              </ul>
            </div>
          </div>
          <!-- MOBILE COMPANY -->
          <!-- <label class="label mobile" for="company">Фирма</label>
          <div class="new-input mobile">
            <span class="miv">Z</span>
            <select
              v-if="$route.name !== 'editReport'"
              id="company"
              class="select"
              v-model="company"
              @change="selectCompany(company), getProjects(), reportChanged()"
            >
              <option value disabled hidden v-if="$route.name !== 'editReport'">
                Име на фирма
              </option>
              <option
                value="Последни фирми:"
                v-if="$route.name !== 'editReport'"
                disabled
              >
                Последни фирми:
              </option>
              <template v-for="c in latestCompanies">
                <option
                  :value="c"
                  v-if="$route.name !== 'editReport'"
                  :key="`latestCompanies-${c._id}`"
                  selected
                >
                  {{ c.companyName }}
                </option>
              </template>
              <option value v-if="$route.name !== 'editReport'" disabled>
                Всички фирми:
              </option>
              <template v-for="(c, index) in companies">
                <option
                  v-if="companies.length && $route.name !== 'editReport'"
                  :value="c"
                  :key="index"
                  selected
                >
                  {{ c.companyName }}
                </option>
              </template>
              <option
                :value="report.company"
                v-if="this.$route.name === 'editReport'"
                selected
                disabled
              >
                {{ report.company.companyName }}
              </option>
            </select>
            <input
              v-else
              type="text"
              placeholder="Име на фирма"
              v-model="report.company.companyName"
              :disabled="
                this.$route.name === 'editReport' || report.company._id.length
              "
            />
            <span v-if="this.$route.name === 'editReport'" class="disabled"
              >A</span
            >
          </div> -->
          <!-- PROJECT -->
          <div class="new-input-wrapper">
            <label for="newReportCompany" >Проект</label>
            <div
              class="new-input"
              :class="{
                'new-input-disabled': this.$route.name === 'editReport',
              }"
            >
              <span class="miv">Z</span>
              <!-- NOT SELECTED -->
              <input
                v-if="!report.project._id.length"
                type="text"
                placeholder="Име на проект"
                @focus="getProjects(), openDropdown(4)"
                @blur="closeDropdown(4)"
                v-model="searchProjects"
                :disabled="this.$route.name === 'editReport'"
              />
              <!-- SELECTED -->
              <input
                v-else
                type="text"
                placeholder="Име на проект"
                @focus="getProjects(), openDropdown(4)"
                @blur="closeDropdown(4)"
                v-model="report.project.projectName"
                :disabled="
                  this.$route.name === 'editReport' || report.project._id.length
                "
              />
              <span
                v-if="
                  report.project._id.length && this.$route.name !== 'editReport'
                "
                class="clear"
                @click="resetSelectedProject()"
                >F</span
              >
              <span v-if="this.$route.name === 'editReport'" class="disabled"
                >A</span
              >
            </div>
            <!-- DROP-DOWN PROJECTS -->
            <div
              class="new-input-dropdown"
              :class="{ 'new-input-dropdown-active': openedDropdown[4] }"
            >
              <ul v-if="projects.length">
                <li
                  v-for="p in filteredProjects()"
                  :key="p._id"
                  @click="selectProject(p)"
                >
                  {{ p.projectName }}
                </li>
              </ul>
            </div>
          </div>
          <!-- MOBILE PROJECT -->
          <!-- <label class="label mobile" for="project">Проект</label>
          <div class="new-input mobile">
            <span class="miv">Z</span>
            <select
              v-if="this.$route.name !== 'editReport'"
              id="project"
              class="select"
              v-model="project"
              @change="selectProject(project), getObjects()"
            >
              <option value disabled hidden>Име на проект</option>
              <template v-for="(p, index) in projects">
                <option :key="index" :value="p">{{ p.projectName }}</option>
              </template>
            </select>
            <input
              v-else
              type="text"
              placeholder="Име на проект"
              v-model="report.project.projectName"
              :disabled="
                this.$route.name === 'editReport' || report.project._id.length
              "
            />
            <span v-if="this.$route.name === 'editReport'" class="disabled"
              >A</span
            >
          </div> -->
          <!-- OBJECT -->
          <div class="new-input-wrapper last-input">
            <label for="newReportCompany">Обект</label>
            <div
              class="new-input"
              :class="{
                'new-input-disabled': this.$route.name === 'editReport',
              }"
            >
              <span class="miv">Z</span>
              <!-- NOT SELECTED -->
              <input
                v-if="!report.object._id.length"
                type="text"
                placeholder="Име на обект"
                @focus="getObjects(), openDropdown(5)"
                @blur="closeDropdown(5)"
                v-model="searchObjects"
                :disabled="this.$route.name === 'editReport'"
              />
              <!-- SELECTED -->
              <input
                v-else
                type="text"
                placeholder="Име на обект"
                @focus="getObjects(), openDropdown(5)"
                @blur="closeDropdown(5)"
                v-model="report.object.objectName"
                :disabled="
                  this.$route.name === 'editReport' || report.object._id.length
                "
              />
              <span
                v-if="
                  report.object._id.length && this.$route.name !== 'editReport'
                "
                class="clear"
                @click="resetSelectedObject()"
                >F</span
              >
              <span v-if="this.$route.name === 'editReport'" class="disabled"
                >A</span
              >
            </div>
            <!-- DROP-DOWN OBJECTS -->
            <div
              class="new-input-dropdown"
              :class="{ 'new-input-dropdown-active': openedDropdown[5] }"
            >
              <ul v-if="objects.length">
                <li
                  v-for="o in filteredObjects()"
                  :key="o._id"
                  @click="selectObject(o)"
                >
                  {{ o.objectName }}
                </li>
              </ul>
            </div>
          </div>
          <!-- MOBILE OBJECT -->
          <!-- <label class="label mobile" for="object">Обект</label>
          <div class="new-input mobile">
            <span class="miv">Z</span>
            <select
              v-if="this.$route.name !== 'editReport'"
              id="object"
              class="select"
              v-model="object"
              @change="selectObject(object)"
            >
              <option value disabled hidden>Име на обект</option>
              <template v-for="(o, index) in objects">
                <option :value="o" :key="index">{{ o.objectName }}</option>
              </template>
            </select>
            <input
              v-else
              type="text"
              placeholder="Име на обект"
              v-model="report.object.objectName"
              :disabled="
                this.$route.name === 'editReport' || report.object._id.length
              "
            />
            <span v-if="this.$route.name === 'editReport'" class="disabled"
              >A</span
            >
          </div> -->
        </div>

        <!-- DESKTOP WORKERS / MATERIALS / ACTIVITIES FIRST ROW SHOWN WHEN VIEW LISTS IS ACTIVE -->
        <div class="new-content-data-row desktop" v-if="allowSave">
          <!-- DESKTOP WORKERS -->
          <div
            class="new-content-data-item"
            v-if="
              selectedObject !== undefined || this.$route.name === 'editReport'
            "
          >
            <div
              class="new-content-data-item-toggle"
              @click="openAddUsersModal()"
            >
              <p>Добави работници</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="miv">V</span>
              </span>
            </div>
          </div>
          <!-- DESKTOP MATERIALS -->
          <!-- <div
            class="new-content-data-item"
            v-if="
              selectedObject !== undefined || this.$route.name === 'editReport'
            "
          >
            <div
              class="new-content-data-item-toggle"
              @click="openAddMaterialsModal()"
            >
              <p>Добави материали</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="miv">T</span>
              </span>
            </div>
          </div> -->
          <!-- DESKTOP ACTIVITIES -->
          <div
            class="new-content-data-item"
            v-if="
              selectedObject !== undefined || this.$route.name === 'editReport'
            "
          >
            <div
              class="new-content-data-item-toggle"
              @click="openAddActivitiesModal()"
            >
              <p>Добави дейности</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="miv">U</span>
              </span>
            </div>
          </div>
        </div>
        <!-- MOBILE WORKERS / MATERIALS / ACTIVITIES FIRST ROW SHOWN WHEN VIEW LISTS IS ACTIVE -->
        <div class="new-content-data-row mobile" v-if="allowSave">
          <!-- MOBILE WORKERS -->
          <div
            class="new-content-data-item new-content-data-item-small"
            v-if="
              selectedObject !== undefined || this.$route.name === 'editReport'
            "
          >
            <div
              class="new-content-data-item-toggle mobile"
              @click="openAddUsersModal()"
            >
              <p>Добави работници</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="miv">V</span>
              </span>
            </div>
          </div>
          <!-- MOBILE MATERIALS -->
          <!-- <div
            class="new-content-data-item new-content-data-item-small"
            v-if="
              selectedObject !== undefined || this.$route.name === 'editReport'
            "
          >
            <div
              class="new-content-data-item-toggle mobile"
              @click="openAddMaterialsModal()"
            >
              <p>Добави материали</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="miv">T</span>
              </span>
            </div>
          </div> -->
          <!-- MOBILE ACTIVITIES -->
          <div
            class="new-content-data-item new-content-data-item-small"
            v-if="
              selectedObject !== undefined || this.$route.name === 'editReport'
            "
          >
            <div
              class="new-content-data-item-toggle mobile"
              @click="openAddActivitiesModal()"
            >
              <p>Добави дейности</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="miv">U</span>
              </span>
            </div>
          </div>
        </div>

        <!-- WORKERS / MATERIALS / ACTIVITIES -->
        <div
          class="new-content-data-row"
          v-if="viewLists()"
          :class="{ 'new-content-data-row-active': viewLists() }"
        >
          <!-- WORKERS -->
          <div
            class="new-content-data-item"
            v-if="
              selectedObject !== undefined || this.$route.name === 'editReport'
            "
          >
            <div
              class="new-content-data-item-toggle mobile"
              @click="openAddUsersModal()"
            >
              <p>Работници</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="miv">V</span>
              </span>
            </div>
            <table>
              <thead
                class="new-content-data-item-toggle desktop"
                @click="openAddUsersModal()"
              >
                <tr>
                  <td
                    class="users-cell users-cell-name"
                    :style="
                      !getUser.permissions.isSuperAdmin ? 'width: 80%' : ''
                    "
                  >
                    Работници
                  </td>
                  <td
                    class="
                      users-cell users-cell-hours users-cell-nowrap
                      desktop
                    "
                  >
                    Изработени часове
                  </td>
                  <td
                    class="users-cell users-cell-nowrap desktop"
                    v-if="getUser.permissions.isSuperAdmin"
                  >
                    Коефициент
                  </td>
                  <td>
                    <span class="new-content-data-item-toggle-circle">
                      <span class="miv">V</span>
                    </span>
                  </td>
                </tr>
              </thead>
            </table>
            <div v-if="viewLists()" class="new-content-data-item-content">
              <table>
                <tr
                  v-for="(worker, i) in report.workers"
                  :key="`addedWorker-${worker._id}`"
                >
                  <td
                    class="users-cell users-cell-name"
                    :style="
                      !getUser.permissions.isSuperAdmin ? 'width: 80%' : ''
                    "
                  >
                    {{ worker.name }}
                  </td>
                  <td class="users-cell users-cell-hours users-cell-nowrap">
                    <div class="hours-and-tags">
                      <SelectHour
                        :reported="
                          report.reported
                            ? report.reported.indexOf(worker._id) > -1
                            : false
                        "
                        :reportedNonplanned="
                          report.reportedNonplanned
                            ? report.reportedNonplanned.indexOf(worker._id) > -1
                            : false
                        "
                        v-model="worker.startHour"
                        :end="worker.endHour"
                        min="07:00"
                        max="20:00"
                        :disabled="report.isInvalid"
                        @change="changeWorker(i)"
                      />
                      <SelectHour
                        :reported="
                          report.reported
                            ? report.reported.indexOf(worker._id) > -1
                            : false
                        "
                        :reportedNonplanned="
                          report.reportedNonplanned
                            ? report.reportedNonplanned.indexOf(worker._id) > -1
                            : false
                        "
                        v-model="worker.endHour"
                        :start="worker.startHour"
                        min="07:00"
                        max="20:00"
                        :disabled="report.isInvalid"
                        @change="changeWorker(i)"
                      />
                      <template
                        v-if="
                          (report.reported
                            ? report.reported.length ||
                              report.notReported.length
                            : false) && !worker.new
                        "
                      >
                        <span
                          class="state-tag state-tag--nonplanned"
                          title="Работникът е допълнително добавен без да е планиран"
                          v-if="
                            report.reportedNonplanned
                              ? report.reportedNonplanned.indexOf(worker._id) >
                                -1
                              : false
                          "
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                          >
                            <path
                              id="add"
                              d="M9,2a4,4,0,1,0,4,4A4,4,0,0,0,9,2ZM4.009,11A2,2,0,0,0,2,13a4.352,4.352,0,0,0,2.135,3.8A9.142,9.142,0,0,0,9,18c.411,0,.816-.019,1.21-.057A5.5,5.5,0,0,1,10.257,11ZM14.5,19A4.5,4.5,0,1,0,10,14.5,4.5,4.5,0,0,0,14.5,19Zm0-7a.5.5,0,0,1,.5.5V14h1.5a.5.5,0,0,1,0,1H15v1.5a.5.5,0,0,1-1,0V15H12.5a.5.5,0,0,1,0-1H14V12.5A.5.5,0,0,1,14.5,12Z"
                              transform="translate(-2 -2)"
                              fill="#212121"
                            />
                          </svg>
                        </span>
                        <span
                          class="state-tag"
                          title="Успешно отчетен планиран работник"
                          v-else
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                          >
                            <path
                              id="ok"
                              d="M5,6a4,4,0,1,1,4,4A4,4,0,0,1,5,6ZM2,13a2,2,0,0,1,2.009-2h6.248a5.5,5.5,0,0,0-.047,6.943c-.395.038-.8.057-1.21.057a9.142,9.142,0,0,1-4.865-1.2A4.352,4.352,0,0,1,2,13Zm17,1.5A4.5,4.5,0,1,1,14.5,10,4.5,4.5,0,0,1,19,14.5Zm-2.146-1.854a.5.5,0,0,0-.707,0L13.5,15.293l-.646-.646a.5.5,0,0,0-.707.707l1,1a.5.5,0,0,0,.707,0l3-3A.5.5,0,0,0,16.854,12.646Z"
                              transform="translate(-2 -2)"
                              fill="#212121"
                            />
                          </svg>
                        </span>
                      </template>
                      <WorktimeTag
                        :date="report.date"
                        :start="worker.startHour"
                        :end="worker.endHour"
                      />
                    </div>
                  </td>
                  <td
                    class="users-cell users-cell-nowrap"
                    v-if="getUser.permissions.isSuperAdmin"
                  >
                    {{ worker.coefficient | formatDecimal }}
                  </td>
                </tr>
                <template v-if="report.notReported">
                  <tr
                    v-for="worker in notReported"
                    :key="`notReportedWorker-${worker._id}`"
                  >
                    <td
                      class="users-cell users-cell-name"
                      :style="
                        !getUser.permissions.isSuperAdmin ? 'width: 80%' : ''
                      "
                    >
                      {{ worker.name }}
                    </td>
                    <td class="users-cell users-cell-hours users-cell-nowrap">
                      <button
                        class="add-to-report"
                        :class="{
                          'add-to-report--elsewhere': report.reportedElsewhere
                            ? report.reportedElsewhere.indexOf(worker._id) > -1
                            : false,
                        }"
                        :title="
                          report.reportedElsewhere
                            ? report.reportedElsewhere.indexOf(worker._id) > -1
                              ? 'Работникът е вече отчетен в друг отчет'
                              : 'Работникът не е отчитан другаде'
                            : ''
                        "
                        @click="addWorkerToReport(worker)"
                      >
                        <template
                          v-if="
                            report.reportedElsewhere
                              ? report.reportedElsewhere.indexOf(worker._id) >
                                -1
                              : false
                          "
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16.205"
                            height="16.205"
                            viewBox="0 0 16.205 16.205"
                          >
                            <path
                              id="rel"
                              d="M9.13,13.992a4.846,4.846,0,0,0,1.37,3.383,10.881,10.881,0,0,1-2.018.182C4.729,17.557,2,15.893,2,13.483v-.463a1.945,1.945,0,0,1,1.945-1.945H10.1A4.84,4.84,0,0,0,9.13,13.992ZM8.482,2A3.889,3.889,0,1,1,4.593,5.889,3.889,3.889,0,0,1,8.482,2Zm1.3,11.992a4.213,4.213,0,1,0,4.213-4.213A4.213,4.213,0,0,0,9.778,13.992Zm3.467-2.645a2.593,2.593,0,0,1,3.015,1.228v-.527a.324.324,0,1,1,.648,0v1.3a.324.324,0,0,1-.324.324h-1.3a.324.324,0,0,1,0-.648h.471a1.945,1.945,0,0,0-3.143-.565A.324.324,0,1,1,12.158,12,2.592,2.592,0,0,1,13.246,11.347Zm1.492,5.29a2.593,2.593,0,0,1-3.015-1.228v.527a.324.324,0,1,1-.648,0v-1.3a.324.324,0,0,1,.324-.324h1.3a.324.324,0,0,1,0,.648h-.471a1.945,1.945,0,0,0,3.143.565.324.324,0,1,1,.458.458A2.592,2.592,0,0,1,14.738,16.637Z"
                              transform="translate(-2 -2)"
                              fill="#212121"
                            /></svg
                        ></template>
                        <template v-else>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                          >
                            <path
                              id="no"
                              d="M14.5,19A4.5,4.5,0,1,0,10,14.5,4.5,4.5,0,0,0,14.5,19Zm.624-2a.625.625,0,1,1-.625-.625A.625.625,0,0,1,15.124,17Zm1.229-3.552a1.513,1.513,0,0,1-.728,1.319l-.277.214c-.246.195-.328.3-.345.448l-.011.156A.5.5,0,0,1,14,15.5a1.48,1.48,0,0,1,.716-1.289L14.994,14c.288-.229.36-.342.36-.544a.884.884,0,0,0-.853-.95.853.853,0,0,0-.854.945.5.5,0,1,1-1,.01A1.849,1.849,0,0,1,14.5,11.5,1.882,1.882,0,0,1,16.353,13.453ZM9,2a4,4,0,1,0,4,4A4,4,0,0,0,9,2ZM4.009,11A2,2,0,0,0,2,13a4.352,4.352,0,0,0,2.135,3.8A9.142,9.142,0,0,0,9,18c.411,0,.816-.019,1.21-.057A5.5,5.5,0,0,1,10.257,11Z"
                              transform="translate(-2 -2)"
                              fill="#212121"
                            />
                          </svg>
                        </template>

                        Добави към отчета
                      </button>
                    </td>
                    <td
                      class="users-cell users-cell-nowrap"
                      v-if="getUser.permissions.isSuperAdmin"
                    ></td>
                  </tr>
                </template>
              </table>
            </div>
          </div>
          <!-- MATERIALS -->
          <!-- <div
            class="new-content-data-item"
            v-if="
              selectedObject !== undefined || this.$route.name === 'editReport'
            "
          >
            <div class="fixed-table-wrapper" v-if="viewLists()">
              <table class="fixed-table">
                <thead @click="openAddMaterialsModal()">
                  <tr>
                    <td>Материали</td>
                    <td>
                      <span class="desktop">Част</span>
                    </td>
                    <td></td>
                    <td>
                      <span class="desktop">Доставчик</span>
                    </td>
                    <td></td>
                    <td>
                      <span class="desktop">Количество</span>
                    </td>
                    <td>
                      <span class="desktop">Ед.Цена</span>
                    </td>
                    <td>
                      <span class="desktop">Сума</span>
                    </td>
                    <td>
                      <span class="new-content-data-item-toggle-circle">
                        <span class="miv">T</span>
                      </span>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td></td>
                  </tr>
                  <template v-for="(m, i) in report.materials">
                    <tr
                      v-for="(ro, j) in m.rows"
                      :key="`addedReportMaterial-${i}-${j}-${m.materialName}`"
                    >
                      <td
                        class="ma-cell ma-cell-name"
                        :class="{ 'ma-cell-additional': m.isAdditional }"
                      >
                        <template v-if="!j">
                          {{ m.materialName }}
                          <span class="miv" v-if="m.isAdditional">G</span>
                        </template>
                      </td>
                      <td class="ma-cell nowrap">
                        {{ ro.part ? ro.part.partName : '' }}
                      </td>
                      <td class="ma-cell" :title="ro.partComment">
                        <span class="comment-span" v-if="ro.partComment">
                          <span class="miv2 miv2--comment">\</span>
                        </span>
                      </td>
                      <td class="ma-cell nowrap">
                        {{ ro.supplier }}
                      </td>
                      <td class="ma-cell" :title="ro.supplierComment">
                        <span class="comment-span" v-if="ro.supplierComment">
                          <span class="miv2 miv2--comment">\</span>
                        </span>
                      </td>
                      <td class="ma-cell nowrap">
                        <input
                          class="ma-cell-input"
                          v-model="ro.quantity"
                          @keyup="changeMaterial(index)"
                          type="number"
                          min="0"
                        />
                        {{ m.materialUnit }}
                      </td>
                      <td class="ma-cell nowrap">{{ ro.price }} лв.</td>
                      <td class="ma-cell nowrap">
                        {{ (+ro.quantity * +ro.price) | formatDecimal }}
                        лв.
                      </td>
                    </tr>
                    <tr class="bottom-row" :key="`bottom-row-${i}`">
                      <td></td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div> -->
          <!-- ACTIVITIES -->
          <div
            class="new-content-data-item"
            v-if="
              selectedObject !== undefined || this.$route.name === 'editReport'
            "
          >
            <div class="fixed-table-wrapper" v-if="viewLists()">
              <table class="fixed-table">
                <thead @click="openAddActivitiesModal()">
                  <tr>
                    <td>Дейности</td>
                    <td>
                      <span class="desktop">Част</span>
                    </td>
                    <td></td>
                    <td>
                      <span class="desktop">Доставчик</span>
                    </td>
                    <td></td>
                    <td>
                      <span class="desktop">Количество</span>
                    </td>
                    <template
                      v-if="
                        getUser.permissions.isSuperAdmin ||
                        getUser.permissions.isAdmin ||
                        getUser.permissions.isHR
                      "
                    >
                      <td>
                        <span class="desktop">Ед.Цена</span>
                      </td>
                      <td>
                        <span class="desktop">Сума</span>
                      </td>
                    </template>
                    <td>
                      <span class="new-content-data-item-toggle-circle">
                        <span class="miv">U</span>
                      </span>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td></td>
                  </tr>
                  <template v-for="(a, i) in report.activities">
                    <tr
                      v-for="(ro, j) in a.rows"
                      :key="`addedReportActivity-${i}-${j}-${a.activitylName}`"
                    >
                      <td
                        class="ma-cell ma-cell-name"
                        :class="{ 'ma-cell-additional': a.isAdditional }"
                      >
                        <template v-if="!j">
                          {{ a.activityName }}
                          <span class="miv" v-if="a.isAdditional">O</span>
                        </template>
                      </td>
                      <td class="ma-cell nowrap">
                        {{ ro.part ? ro.part.partName : "" }}
                      </td>
                      <td class="ma-cell" :title="ro.partComment">
                        <span class="comment-span" v-if="ro.partComment">
                          <span class="miv2 miv2--comment">\</span>
                        </span>
                      </td>
                      <td class="ma-cell nowrap">
                        {{ ro.supplier }}
                      </td>
                      <td class="ma-cell" :title="ro.supplierComment">
                        <span class="comment-span" v-if="ro.supplierComment">
                          <span class="miv2 miv2--comment">\</span>
                        </span>
                      </td>
                      <td class="ma-cell nowrap">
                        <input
                          class="ma-cell-input"
                          v-model="ro.quantity"
                          @keyup="changeActivity(i)"
                          type="number"
                          min="0"
                          :disabled="report.isInvalid"
                        />
                        {{ a.activityUnit }}
                      </td>
                      <template
                        v-if="
                          getUser.permissions.isSuperAdmin ||
                          getUser.permissions.isAdmin ||
                          getUser.permissions.isHR
                        "
                      >
                        <td class="ma-cell nowrap">{{ ro.price }} лв.</td>
                        <td class="ma-cell nowrap">
                          {{ (+ro.quantity * +ro.price) | formatDecimal }}
                          лв
                        </td>
                      </template>
                    </tr>
                    <tr class="bottom-row" :key="`bottom-row-${i}`">
                      <td></td>
                    </tr>
                  </template>
                  <!-- <tr>
                    <td></td>
                  </tr> -->
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="invalid-report-wrap"
            v-if="this.$route.name === 'editReport'"
          >
            <p>
              <strong>Маркиране на отчет като сгрешен</strong> - ако смятате, че
              сте объркали данните в отчета, го отбележете като грешен. Ще бъде
              видим, но няма да се зачита.
            </p>
            <div class="switch-wrapper">
              <div class="switch-container">
                <label class="switch">
                  <input
                    type="checkbox"
                    v-model="report.isInvalid"
                    @change="reportChanged()"
                    :disabled="!allowSave"
                  />
                  <span class="slider"></span>
                </label>
              </div>
              <label class="switch-label" @click="report.isInvalid = true">
                <img
                  v-if="report.isInvalid"
                  class="flag"
                  src="../assets/img/flag_yes.svg"
                  alt="Invalid"
                />
                <img
                  v-else
                  class="flag"
                  src="../assets/img/flag_no.svg"
                  alt="Valid"
                />
                Грешен отчет
              </label>
            </div>
          </div>
        </div>
        <!-- NEW USER BUTTONS MOBILE -->
        <div class="btns mobile" v-if="allowSave">
          <button class="btn btn-close" @click="cancelReport()">
            <span class="miv">F</span>
            Отказ
          </button>
          <button class="btn btn-new" @click="save()">
            <span class="miv">Y</span>
            Запис
          </button>
        </div>
      </div>
    </div>
    <!-- ADD WORKERS/MATERIALS/ACTIVITIES MODALS -->
    <transition name="fade">
      <AddUsersModal
        v-if="isAddUsersModalOpened"
        :isCommingFromReport="true"
        :incomingUsers="report.workers"
        :usersType="'workers'"
      />
    </transition>
    <transition name="fade">
      <AddMaterialsModal
        v-if="isAddMaterialsModalOpened"
        :isComingFromReport="true"
        :companyId="report.company._id"
        :projectId="report.project._id"
        :objectId="report.object._id"
        :incomingMaterials="selectedObject.materials"
        :parts="parts"
      />
    </transition>
    <transition name="fade">
      <AddActivitiesModal
        v-if="isAddActivitiesModalOpened"
        :isComingFromReport="true"
        :companyId="report.company._id"
        :projectId="report.project._id"
        :objectId="report.object._id"
        :incomingActivities="selectedObject.activities"
        :parts="parts"
      />
    </transition>
    <transition name="fade">
      <UnsavedChangesModal v-if="isUnsavedChangesModalOpened" />
    </transition>
    <transition name="fade">
      <ElsewhereModal
        v-if="reportedElsewhereForConfirmation.length"
        :workers="reportedElsewhereForConfirmation"
        @confirmed="reportedElsewhereConfirmed"
        @declined="reportedElsewhereDeclined"
      />
    </transition>
  </div>
</template>

<script>
import hours from "./mixins/hours.js";
import AddUsersModal from "./shared/AddUsersModal";
import AddMaterialsModal from "./shared/AddMaterialsModal";
import AddActivitiesModal from "./shared/AddActivitiesModal";
import UnsavedChangesModal from "./shared/UnsavedChangesModal";
import WorktimeTag from "./shared/WorktimeTag";
import SelectHour from "./shared/SelectHour";
import ElsewhereModal from "./shared/ElsewhereModal";
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import { bg } from "vuejs-datepicker/dist/locale";
import { format } from "date-fns";
import log from "./mixins/log.js";

export default {
  components: {
    AddUsersModal,
    AddMaterialsModal,
    AddActivitiesModal,
    UnsavedChangesModal,
    Datepicker,
    SelectHour,
    WorktimeTag,
    ElsewhereModal,
  },
  mixins: [hours, log],
  watch: {
    "report.date"(to) {
      if (!(to.getTime() < this.today.getTime())) {
        this.report.date = new Date();
        this.$snotify.error("Не можете да създавате отчети с бъдеща дата!");
      }

      this.report.date.setHours(12, 0, 0, 0);
      this.formatedDate = format(new Date(this.report.date), 'dd/MM/yyyy')
    },
    // ,
    // "report.company"(to) {
    //   if(this.report)
    //   this.company = this.report.company;
    //   // console.log(this.company);
    // },
    // "report.project"(to) {
    //   if(this.report)
    //   this.project = this.report.project;
    // },
    // "report.object"(to) {
    //   if(this.report)
    //   this.object = this.report.object;
    // },
    // "report.part"(to) {
    //   if(this.report)
    //   this.part = this.report.part;
    // }
  },
  data() {
    return {
      // Vars for select v-model
      company: "",
      project: "",
      object: "",
      part: "",
      isReportChanged: false,
      // Vars for date picker
      bg: bg,
      formatedDate: "",
      today: undefined,
      // А boolean for every dropdown in the template
      openedDropdown: [false, false, false, false, false, false, false],
      // A boolean for the modal for workers selection
      isAddUsersModalOpened: false,
      isAddMaterialsModalOpened: false,
      isAddActivitiesModalOpened: false,
      isUnsavedChangesModalOpened: false,
      // SEARCH
      searchCompanies: "",
      searchProjects: "",
      searchObjects: "",
      searchParts: "",
      // The main company object
      companies: [],
      latestCompanies: [{ company: { _id: "", companyName: "" } }],
      projects: [],
      objects: [],
      parts: [],
      reportedElsewhereForConfirmation: [],
      selectedObject: undefined,
      allowSave: true,
      saving: false,
      // The main report object
      isSavedAsInvalid: false,
      report: {
        date: undefined,
        startHour: "08:00",
        endHour: "17:00",
        overtime: false,
        createdBy: {
          _id: "",
          name: "",
        },
        company: {
          _id: "",
          companyName: "",
        },
        project: {
          _id: "",
          projectName: "",
        },
        object: {
          _id: "",
          objectName: "",
        },
        part: {
          _id: "",
          partName: "",
        },
        isInvalid: false,
        workers: [],
        materials: [],
        activities: [],
      },
    };
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser",
      // ...
    ]),
    notReported() {
      return this.report.notReported
        ? this.report.notReported.filter(
            (w) => this.report.workers.map((w) => w._id).indexOf(w._id) < 0
          )
        : [];
    },
  },
  methods: {
    // Open dropdown. Depends on index (hard coded in template)
    openDropdown(i) {
      this.$set(this.openedDropdown, i, true);
    },
    // Close dropdown. Depends on index (hard coded in template)
    closeDropdown(i) {
      setTimeout(() => {
        this.$set(this.openedDropdown, i, false);
      }, 100);
    },
    // SELECTING
    // 1 - SELECT COMPANY BY ID
    selectCompany(company) {
      this.resetSelectedProject();
      this.report.company = company;
      // console.log(this.report.company);
    },
    // 2 - SELECT THE INDEX OF A 'PROJECT' INSIDE COMPANY
    selectProject(project) {
      this.resetSelectedObject();
      this.report.project = project;
    },
    // 3 - SELECT THE INDEX OF AN 'OBJECT' INSIDE A PROJECT
    selectObject(object) {
      this.resetSelectedPart();
      this.report.object = object;
      this.getSelectedObject(object._id);

      this.getParts();
    },
    // 4 - SELECT THE INDEX OF A 'PART' INSIDE AN OBJECT
    selectPart(part) {
      this.report.part = part;
    },
    // RESET SELECTED AND EVERYTHING NESTED INSIDE ON FOCUS
    resetSelectedCompany() {
      this.report.company = {
        _id: "",
        companyName: "",
      };
      this.searchCompanies = "";
      this.company = "";
      this.resetSelectedProject();
    },
    resetSelectedProject() {
      this.projects = [];
      this.searchProjects = "";
      this.report.project = {
        _id: "",
        projectName: "",
      };
      this.project = "";
      this.resetSelectedObject();
    },
    resetSelectedObject() {
      this.objects = [];
      this.searchObjects = "";
      this.report.object = {
        _id: "",
        objectName: "",
      };
      this.selectedObject = undefined;
      this.report.workers = [];
      this.report.materials = [];
      this.report.activities = [];
      this.object = "";
      this.resetSelectedPart();
    },
    resetSelectedPart() {
      this.reportChanged();
      this.parts = [];
      this.searchParts = "";
      this.report.part = {
        _id: "",
        partName: "",
      };
      this.part = "";
    },
    // FILTERED RESULTS WHEN SEARCHING
    filteredCompanies() {
      if (this.companies.length) {
        return this.companies.filter((c) => {
          return c.companyName
            .toLowerCase()
            .includes(this.searchCompanies.toLowerCase());
        });
      }
    },
    filteredProjects() {
      if (this.report.company._id && this.projects.length) {
        return this.projects.filter((p) => {
          return p.projectName
            .toLowerCase()
            .includes(this.searchProjects.toLowerCase());
        });
      }
    },
    filteredObjects() {
      if (this.report.project._id && this.objects.length) {
        return this.objects.filter((o) => {
          return o.objectName
            .toLowerCase()
            .includes(this.searchObjects.toLowerCase());
        });
      }
    },
    filteredParts() {
      if (this.report.object._id && this.parts.length) {
        return this.parts.filter((p) => {
          return p.partName
            .toLowerCase()
            .includes(this.searchParts.toLowerCase());
        });
      }
    },
    // We have a selected workers, materials OR activities at least and change styles in template
    viewLists() {
      return (
        this.report.workers.length ||
        this.report.materials.length ||
        this.report.activities.length ||
        (this.report.notReported ? this.report.notReported.length : false) ||
        (this.report.reportedElsewhere
          ? this.report.reportedElsewhere.length
          : false)
      );
    },
    handleDateChange() {
      if (this.selectedObject && !this.report._id) {
        this.$nextTick(() => {
          this.getPlannedWorkers();
        });
      }
    },
    addWorkerToReport(w) {
      this.report.workers.push({
        ...w,
        startHour: "08:00",
        endHour: "17:00",
        new: true,
      });
      this.checkForReportedElsewhereWorkers();
    },
    // If we get the 'saveWorkersModal' event, we assign the workers we receive to the report
    handleWorkers(workers) {
      this.report.workers = [];

      for (let w of workers) {
        if (!w.startHour && !w.endHour) {
          this.$set(w, "startHour", "08:00");
          this.$set(w, "endHour", "17:00");
          this.$set(w, "new", true);
        }
        this.report.workers.push(w);
      }

      this.closeAddWorkersModal();
      this.reportChanged();
      this.checkForReportedElsewhereWorkers();
    },
    checkForReportedElsewhereWorkers() {
      if (!this.report.reportedElsewhere) return;

      for (let w of this.report.workers) {
        if (w.new && !w.elsewhereConfirmed) {
          if (this.report.reportedElsewhere.indexOf(w._id) > -1) {
            this.reportedElsewhereForConfirmation.push(w);
          }
        }
      }
    },
    reportedElsewhereConfirmed(id) {
      const i = this.report.workers.map((w) => w._id).indexOf(id);

      if (i > -1) {
        this.$set(this.report.workers[i], "elsewhereConfirmed", true);
      }

      const j = this.reportedElsewhereForConfirmation
        .map((w) => w._id)
        .indexOf(id);
      if (j > -1) this.reportedElsewhereForConfirmation.splice(j, 1);
    },
    reportedElsewhereDeclined(id) {
      const i = this.report.workers.map((w) => w._id).indexOf(id);

      if (i > -1) {
        this.report.workers.splice(i, 1);
      }

      const j = this.reportedElsewhereForConfirmation
        .map((w) => w._id)
        .indexOf(id);
      if (j > -1) this.reportedElsewhereForConfirmation.splice(j, 1);
    },
    handleMaterials(materials) {
      this.selectedObject.materials.forEach((m) => {
        if (m.isSelected) {
          m.isSelected = false;
        }
      });
      // Items are zero by default
      materials.forEach((m) => {
        if (m.materialItems === undefined) {
          m.materialItems = 0;
        }
        // add a temporary id just to know that the material is a new one
        // the tempId will be removed before sent
        if (m.isAdditional && !m._id) {
          const now = new Date();
          m._id = `${Math.random().toString(36).substr(2, 9)}-${now.getTime()}`;
          this.selectedObject.materials.unshift(m);
          m.tempId = true;
        }
      });
      this.report.materials = materials;
      this.updateMaterials();
      this.closeAddMaterialsModal();
      this.reportChanged();
    },
    handleActivities(activities) {
      this.selectedObject.activities.forEach((a) => {
        if (a.isSelected) {
          a.isSelected = false;
        }
      });
      // Items are zero by default
      activities.forEach((a) => {
        if (a.activityItems === undefined) {
          a.activityItems = 0;
        }
        // add a temporary id just to know that the activity is a new one
        // the tempId will be removed before sent
        if (a.isAdditional && !a._id) {
          const now = new Date();
          a._id = `${Math.random().toString(36).substr(2, 9)}-${now.getTime()}`;
          this.selectedObject.activities.unshift(a);
          a.tempId = true;
        }
      });
      this.report.activities = activities;
      this.updateActivities();
      this.closeAddActivitiesModal();
      this.reportChanged();
    },
    openAddUsersModal() {
      if (this.allowSave) {
        this.isAddUsersModalOpened = true;
      }
    },
    openAddMaterialsModal() {
      if (this.allowSave) {
        this.isAddMaterialsModalOpened = true;
      }
    },
    openAddActivitiesModal() {
      if (this.allowSave) {
        this.isAddActivitiesModalOpened = true;
      }
    },
    // Close the workers modal
    closeAddWorkersModal() {
      this.isAddUsersModalOpened = false;
    },
    closeAddMaterialsModal() {
      this.isAddMaterialsModalOpened = false;
    },
    closeAddActivitiesModal() {
      this.isAddActivitiesModalOpened = false;
    },
    // JUST FOR THE CASE OF REACTIVITY TO WORK AND NOT USE forceUpdate()
    changeWorker(i) {
      this.$set(this.report.workers, i, this.report.workers[i]);
      this.reportChanged();
    },
    changeMaterial(i) {
      this.$set(this.report.materials, i, this.report.materials[i]);
      this.reportChanged();
    },
    changeActivity(i) {
      this.$set(this.report.activities, i, this.report.activities[i]);
      this.reportChanged();
    },
    updateMaterials() {
      this.report.materials.map((m) => {
        const material = this.selectedObject.materials.find((fm) => {
          return fm._id === m._id;
        });
        if (material) {
          material.isSelected = true;
          material.materialItems = m.materialItems;
          material.rows = m.rows;
        } else {
          m.isSelected = true;
          this.selectedObject.materials.unshift(m);
        }
      });
    },
    updateActivities() {
      this.report.activities.map((a) => {
        const activity = this.selectedObject.activities.find((fa) => {
          return fa._id === a._id;
        });
        if (activity) {
          activity.isSelected = true;
          activity.activityItems = a.activityItems;
          activity.rows = a.rows;
        } else {
          a.isSelected = true;
          this.selectedObject.activities.unshift(a);
        }
      });
    },
    // GET ALL COMPANIES REQUEST
    getCompanies() {
      this.companies = [];
      let id = this.getUser._id;
      let requestUrl = `${process.env.VUE_APP_BASE_URI}/company/reporters/companies/${id}`;
      this.$http
        .get(requestUrl)
        .then((response) => {
          this.companies = response.data;
          // console.log(this.companies);
        })
        .catch((error) => console.log(error));
    },
    // GET LATEST REPORTED COMPANIES
    getLatestUsedCompanies() {
      const id = this.getUser._id;
      const url = `${process.env.VUE_APP_BASE_URI}/report/limited/${id}/5`;
      this.$http
        .get(url)
        .then((response) => {
          this.latestCompanies = response.data;
          // console.log(this.latestCompanies);
        })
        .catch((error) => console.log(error));
    },
    // GET ALL VISIBLE PROJECTS INSIDE THE SELECTED COMPANY
    getProjects() {
      this.projects = [];
      if (this.report.company._id.length) {
        let id = this.getUser._id;
        let requestUrl = `${process.env.VUE_APP_BASE_URI}/company/reporters/projects/${this.report.company._id}/${id}`;
        this.$http
          .get(requestUrl)
          .then((response) => {
            this.projects = response.data;
          })
          .catch((error) => console.log(error));
      }
    },
    // GET ALL VISIBLE OBJECTS INSIDE THE SELECTED PROJECT
    getObjects() {
      this.objects = [];
      if (this.report.project._id.length) {
        let id = this.getUser._id;
        let requestUrl = `${process.env.VUE_APP_BASE_URI}/company/reporters/objects/${this.report.company._id}/${this.report.project._id}/${id}`;
        this.$http
          .get(requestUrl)
          .then((response) => {
            this.objects = response.data;
            // console.log(this.objects);
          })
          .catch((error) => console.log(error));
      }
    },
    // GET ALL VISIBLE PARTS INSIDE THE SELECTED OBJECT
    getParts() {
      this.parts = [];
      if (this.report.project._id.length) {
        let id = this.getUser._id;
        let requestUrl = `${process.env.VUE_APP_BASE_URI}/company/reporters/parts/${this.report.company._id}/${this.report.project._id}/${this.report.object._id}/${id}`;
        this.$http
          .get(requestUrl)
          .then((response) => {
            this.parts = response.data;
          })
          .catch((error) => console.log(error));
      }
    },
    // GET SPECIFIC PART BY ID REQUEST
    getSelectedObject(id) {
      this.selectedObject = undefined;
      let url = `${process.env.VUE_APP_BASE_URI}/company/object/${id}`;
      return this.$http
        .get(url)
        .then((response) => {
          this.selectedObject = response.data[0];
          if (this.$route.name !== "editReport") {
            this.getPlannedWorkers();
          }
        })
        .catch((error) => console.log(error));
    },
    getMaterials() {
      let url = `${process.env.VUE_APP_BASE_URI}/company/object/${this.selectedObject._id}`;
      return this.$http
        .get(url)
        .then((response) => {
          this.selectedObject.materials = response.data[0].materials;
          this.updateMaterials();
        })
        .catch((error) => console.log(error));
    },
    getActivities() {
      let url = `${process.env.VUE_APP_BASE_URI}/company/object/${this.selectedObject._id}`;
      return this.$http
        .get(url)
        .then((response) => {
          this.selectedObject.activities = response.data[0].activities;
          this.updateActivities();
        })
        .catch((error) => console.log(error));
    },
    // GET SPECIFIC REPORT
    getReport(id) {
      let url = `${process.env.VUE_APP_BASE_URI}/report/${id}`;
      this.$http
        .get(url)
        .then((response) => {
          this.getSelectedObject(response.data.object._id).then(() => {
            this.report = response.data;
            this.report.date = new Date(response.data.date);
            this.isSavedAsInvalid = !!this.report.isInvalid
            // ADD IS SELECTED PROPERTY AND ITEMS COUNT TO ALL MATERIALS ADDED TO THE REPORT
            this.updateMaterials();
            // ADD IS SELECTED PROPERTY AND ITEMS COUNT TO ALL ACTIVITIES ADDED TO THE REPORT
            this.updateActivities();
            this.getParts();
            if (this.report.isInvalid) {
              this.allowSave = false;
              this.$snotify.warning(
                "Грешните отчети не могат да бъдат редактирани!"
              );
            } else if (this.isReportLocked()) {
              this.allowSave = false;
              this.$snotify.warning(
                "Редакцията за отчета е заключена, моля обърнете се към администратор"
              );
            }

            this.getPlannedWorkers(id);
          });
        })
        .catch((error) => console.log(error));
    },
    getPlannedWorkers(id) {
      let url = `${process.env.VUE_APP_BASE_URI}/report`;
      if (id) {
        url += `/${id}?reported=true`;
      } else {
        url += `/planned`;
        url += `/${this.report.company._id}`;
        url += `/${this.report.project._id}`;
        url += `/${this.report.object._id}`;
        url += `/${this.report.date.toISOString()}`;
      }
      this.$http
        .get(url)
        .then((res) => {
          this.$set(this.report, "reported", res.data.reported);
          this.$set(
            this.report,
            "reportedElsewhere",
            res.data.reportedElsewhere
          );
          this.$set(
            this.report,
            "reportedNonplanned",
            res.data.reportedNonplanned
          );
          this.$set(this.report, "notReported", res.data.notReported);
        })
        .catch((error) => console.log(error));
    },
    // reporters can edit reports only 24h after creation and before they are logged (актувани)
    isReportLocked() {
      const p = this.getUser.permissions;
      if (p.isAdmin || p.isSuperAdmin) return false;
      if (this.report.isLogged) return true;

      const createdAt = new Date(this.report.createdAt || this.report.date);
      return Date.now() - createdAt.getTime() > 24 * 60 * 60 * 1000;
    },
    isValid() {
      if (!this.report.company._id.length) {
        this.$snotify.error("Не сте избрали фирма!");
        return false;
      }
      if (!this.report.project._id.length) {
        this.$snotify.error("Не сте избрали проект!");
        return false;
      }
      if (!this.report.object._id.length) {
        this.$snotify.error("Не сте избрали обект!");
        return false;
      }
      if (!this.report.workers.length) {
        this.$snotify.error("Трябва да сте избрали поне един работник!");
        return false;
      }
      // reports marked as invalid can be saved without activities
      if (!this.report.activities.length && !this.report.isInvalid) {
        this.$snotify.error("Моля въведете дейност");
        return false;
      }
      for (let m of this.report.materials) {
        for (let ro of m.rows) {
          if (ro.quantity <= 0) {
            this.$snotify.error(
              "Количеството на всички добавени материали трябва да е по-голямо от 0"
            );
            return false;
          }
        }
      }
      for (let a of this.report.activities) {
        for (let ro of a.rows) {
          if (ro.quantity <= 0) {
            this.$snotify.error(
              "Количеството на всички добавени дейности трябва да е по-голямо от 0"
            );
            return false;
          }
        }
      }
      return true;
    },
    removeTempIds() {
      if (this.report.materials.length) {
        this.report.materials.map((m) => {
          if (m.tempId) {
            delete m._id;
          }
        });
      }
      if (this.report.activities.length) {
        this.report.activities.map((a) => {
          if (a.tempId) {
            delete a._id;
          }
        });
      }
    },
    validateReport() {
      let url = `${process.env.VUE_APP_BASE_URI}/report/validate-report`;
      return this.$http.post(url, this.report);
    },
    // POST NEW REPORT
    postReport() {
      this.saving = true;
      if (this.isValid()) {
      this.report.createdAt = new Date();
        this.validateReport().then((a) => {
          if (a.data.errors) {
            this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
            this.saving = false;
          }
          if (a.data.exists.length) {
            for (let i = 0; i < a.data.exists.length; i++) {
              this.$snotify.error(
                `${a.data.exists[i].workers.name} е вече добавен към друг отчет в диапазона ${a.data.exists[i].workers.startHour} - ${a.data.exists[i].workers.endHour}`
              );
            }
            this.saving = false;
          } else {
            this.removeTempIds();
            this.report.createdBy._id = this.getUser._id;
            this.report.createdBy.name = this.getUser.name;
            if (this.report.part) {
              if (!this.report.part._id) {
                delete this.report.part;
              }
            }
            let url = `${process.env.VUE_APP_BASE_URI}/report`;
            this.$http
              .post(url, this.report)
              .then((a) => {
                if (a.data.errors) {
                  this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
                  this.saving = false;
                } else {
                  this.$snotify.success("Вашият отчет беше създаден успешно!");
                  this.newLog(
                    "newReport",
                    `обект - ${this.report.object.objectName}`
                  );
                  this.isReportChanged = false;
                  this.saving = false;
                  this.cancelReport();
                }
              })
              .catch((error) => {
                console.log(error.response);
                this.$snotify.error(
                  (error.response && error.response.data.failed) ||
                    "Нещо се обърка! Моля опитайте отново."
                );
                this.saving = false;
              });
          }
        });
      } else {
        this.saving = false;
      }
    },
    // EDIT REPORT
    editReport() {
      this.saving = true;
      if (this.isValid()) {
        this.validateReport().then((a) => {
          if (a.data.errors) {
            this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
            this.saving = false;
          }
          if (a.data.exists.length) {
            for (let i = 0; i < a.data.exists.length; i++) {
              this.$snotify.error(
                `${a.data.exists[i].workers.name} е вече добавен към друг отчет в диапазона ${a.data.exists[i].workers.startHour} - ${a.data.exists[i].workers.endHour}`
              );
            }
            this.saving = false;
          } else {
            this.removeTempIds();
            let url = `${process.env.VUE_APP_BASE_URI}/report/${this.$route.params.id}`;
            this.$http
              .put(url, this.report)
              .then(() => {
                this.$snotify.success("Промените са записани успешно!");
                this.isReportChanged = false;
                this.newLog(
                  "editReport",
                  `обект - ${this.report.object.objectName}`
                );
                this.saving = false;
                this.cancelReport();
              })
              .catch((error) => {
                console.log(error);
                this.$snotify.error(
                  (error.response && error.response.data.failed) ||
                    "Нещо се обърка! Моля опитайте отново."
                );
                this.saving = false;
              });
          }
        });
      } else {
        this.saving = false;
      }
    },
    goBack() {
      if (this.$route.query.back) {
        this.$router.go(-1);
      } else {
        this.cancelReport();
      }
    },
    // Cancel report and go back 1 route behind
    cancelReport() {
      this.$router.push("/reports/own");
      // this.$router.go(-1);
    },
    reportChanged() {
      if (!this.isReportChanged) {
        this.isReportChanged = true;
      }
    },
    save() {
      if (!this.saving) {
        if (this.$route.name === "newReport") {
          this.postReport();
        } else if (this.$route.name === "editReport") {
          this.editReport();
        }
      }
    },
    checkForUnsavedData(next) {
      this.isUnsavedChangesModalOpened = true;
      this.$once("closeUnsavedChangesModal", (answer) => {
        // confirm
        if (answer) {
          next(false);
          this.save();
        }
        // decline
        else {
          next();
        }
        this.isUnsavedChangesModalOpened = false;
        this.isReportChanged = false;
      });
    },
  },
  mounted() {
    this.today = new Date();
    this.today.setHours(23, 59, 59, 999);

    this.getCompanies();
    this.getLatestUsedCompanies();
    if (this.$route.name === "newReport") {
      this.report.date = new Date();
    } else if (this.$route.name === "editReport") {
      this.getReport(this.$route.params.id);
    }
    // Start listening for children's events
    this.$on("saveAddUsersModal", this.handleWorkers);
    this.$on("saveAddMaterialsModal", this.handleMaterials);
    this.$on("saveAddActivitiesModal", this.handleActivities);
    this.$on("getMaterialsAgain", this.getMaterials);
    this.$on("getActivitiesAgain", this.getActivities);
    // Close listening for children's events
    this.$on("closeAddUsersModal", this.closeAddWorkersModal);
    this.$on("closeAddMaterialsModal", this.closeAddMaterialsModal);
    this.$on("closeAddActivitiesModal", this.closeAddActivitiesModal);
  },
  beforeRouteLeave(to, from, next) {
    if (this.isReportChanged && !this.isSavedAsInvalid) {
      this.checkForUnsavedData(next);
    } else {
      next();
    }
  },
  destroyed() {
    // Stop listening
    this.$off("saveAddUsersModal");
    this.$off("saveAddMaterialsModal");
    this.$off("saveAddActivitiesModal");
    this.$off("getMaterialsAgain");
    this.$off("getActivitiesAgain");

    this.$off("closeAddUsersModal");
    this.$off("closeAddMaterialsModal");
    this.$off("closeAddActivitiesModal");
  },
};
</script>

<style scoped>
.new-report {
  padding: 10px 40px;
}
.report-header {
  align-items: center;
  display: flex;
  height: 36px;
  justify-content: space-between;
  margin-bottom: 10px;
}
.heads {
  align-items: center;
  display: flex;
  justify-content: flex-start;
}
.title {
  margin-left: 0.5em;
}
.italic {
  font-style: italic;
}
.italic::placeholder {
  font-style: italic;
}
.italic::-moz-placeholder {
  font-style: italic;
}
.italic:-moz-placeholder {
  font-style: italic;
}
.italic:-ms-input-placeholder {
  font-style: italic;
}
.italic::-webkit-input-placeholder {
  font-style: italic;
}
/*
.desktop {
   display: flex; 
}
*/
.mobile {
  display: none;
}
.btn.new-content-data-item-toggle-circle {
  margin-left: 0;
}
.date {
  cursor: pointer;
}
.indicator-display {
  align-items: center;
  display: flex;
  height: 40px;
  justify-content: space-between;
  padding: 5px 15px 5px 40px;
}
.indicator-inactive {
  background-color: #c4c4c4;
}
.new-wrapper-invalid {
  background-color: #fff8f8;
}
.invalid-report-wrap {
  align-items: center;
  background-color: #f4f4f4;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  padding: 10px;
}
.invalid-report-wrap .switch-wrapper {
  align-items: center;
  display: flex;
}
.invalid-report-wrap .switch {
  margin: 0;
}
.invalid-report-wrap .switch-label {
  align-items: center;
  display: flex;
}
.invalid-report-wrap .slider {
  background-color: #c4c4c4;
}
.invalid-report-wrap input:checked + .slider {
  background-color: #9f0510;
}
.invalid-report-wrap .flag {
  height: 24px;
  margin: 0 8px;
}
.invalid-report-wrap > p {
  padding-right: 20px;
}
.title .flag {
  height: 24px;
  vertical-align: baseline;
  margin: 0 5px;
}
.title span {
  display: inline-flex;
  align-items: center;
}
.fixed-table-wrapper {
  overflow: auto;
  width: 100%;
}
.fixed-table {
  border-collapse: collapse;
}
.fixed-table thead td {
  background-color: #e8e8e8;
  cursor: pointer;
  padding: 10px;
  transition: all 0.3s;
  white-space: nowrap;
}
.fixed-table thead tr:hover td {
  background-color: #d8d8d8;
}
.fixed-table thead tr:hover .new-content-data-item-toggle-circle .miv,
.fixed-table thead tr:hover .new-content-data-item-toggle-circle .miv2 {
  border-color: #fff;
}

.fixed-table thead td:first-child {
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}
.fixed-table thead td:last-child {
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  padding-bottom: 0;
  padding-top: 0;
}
.fixed-table td:first-child {
  width: 100%;
}
.fixed-table thead .new-content-data-item-toggle-circle {
  position: relative;
  right: 0;
  top: 5px;
}
.fixed-table tbody tr td {
  color: #737373;
  font-size: 11px;
  padding: 1px 10px;
  position: relative;
  vertical-align: middle;
}
.fixed-table tbody tr td:first-child {
  padding-left: 30px;
}
.fixed-table tbody tr td:first-child .miv {
  left: 10px;
  /* -webkit-transform: initial; */
  /* transform: none; */
  top: 50%;
}
.comment-span {
  align-items: center;
  display: inline-flex;
}
.miv2--comment {
  color: #005a9e;
  font-size: 13px;
  margin-right: 5px;
  vertical-align: middle;
}
.fixed-table tbody tr:first-child td {
  padding-top: 10px;
}
.fixed-table tbody tr:last-child td {
  padding-bottom: 10px;
}
.nowrap {
  white-space: nowrap;
}
.hours-and-tags {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}
.bottom-row td {
  padding: 10px 0 0 !important;
}
.state-tag {
  align-items: center;
  background: #a9d2a7;
  border-radius: 4px;
  display: inline-flex;
  height: 20px;
  justify-content: center;
  margin: 0 2px;
  width: 34px;
}
.state-tag svg {
  height: 17px;
  width: 17px;
}
.state-tag--nonplanned {
  background: #9fd3e3;
}
.add-to-report {
  align-items: center;
  background: #ebbdbd;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  font-weight: 700;
  height: 20px;
  justify-content: center;
  margin: 0 5px 0 2px;
  padding: 0 1rem;
  transition: background-color 0.3s;
  width: initial;
  /* width: calc(100% - 7px); */
}
.add-to-report svg {
  height: 17px;
  margin-right: 7px;
  width: 17px;
}
.add-to-report--elsewhere {
  background: #ecc98c;
}
.add-to-report:hover {
  background: #dbdada;
}
/* Responsive */
@media screen and (max-width: 1280px) {
  .indicator-display {
    padding-right: 2px;
  }
  .indicator-display .indicators {
    display: inline-flex;
  }
  .indicator-display .worktime-indicator {
    height: 34px;
    margin: 0 2px;
    width: 14px;
  }
  .indicator-display .worktime-indicator span {
    transform: rotate(-90deg);
    font-size: 9px;
    white-space: nowrap;
    font-weight: 700;
  }
}
@media screen and (max-width: 1000px) {
  .mobile {
    display: flex;
    width: 100%;
    flex-direction: row;
  }
  .new-report {
    padding: 10px 15px;
  }
  .new-content-inputs.desktop,
  .desktop {
    display: none;
  }
  .new-content {
    width: 100%;
  }
  .new-content-inputs.mobile {
    display: flex;
    flex-direction: column;
  }
  .new-input-wrapper {
    width: 100%;
  }
  /* .new-input.mobile.drop {
    padding: 15px;
  } */
  .new-content-inputs {
    flex-direction: column;
  }
  .date-irv-wrapper {
    display: flex;
    width: 100%;
  }
  /* .datepicker-dropdown-active {
    width: 210%;
  } */
  .start-end-wrapper {
    display: flex;
    width: 100%;
  }
  .report-header {
    justify-content: flex-start;
  }
  .new-content-data-item-toggle.mobile {
    text-align: center;
    /* flex-direction: column; */
    height: auto;
    padding-bottom: 0.6em;
  }
  .new-content-data-item-small {
    width: calc(33.33% - 13.33px);
  }
  .new-content-data-item-small .new-content-data-item-toggle.mobile {
    flex-direction: column;
  }
  .new-content-data-item-toggle.mobile p {
    margin-top: 0.6em;
    margin-bottom: 0.6em;
    margin-right: 0px;
  }
  .new-content-data-item-content {
    overflow: auto;
  }
  .new-content-data-item-content .ma-cell,
  .new-content-data-item-content .users-cell,
  .new-content-data-item-togle .ma-cell {
    padding: 0px 10px 0 0;
  }
  .new-content-data-item-content .ma-cell-additional {
    padding-left: 15px;
  }
  .new-content-data-item-content .ma-cell-nowrap {
    white-space: nowrap;
  }
  .new-content-data-item-content .users-cell p {
    align-items: center;
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    margin-right: 0px;
  }
  .btns.mobile {
    display: flex;
    justify-content: center;
    margin-top: 1.5em;
    margin-bottom: 1.5em;
  }
  .label {
    color: #373737;
    font-size: 11px;
    font-weight: 700;
  }
}
@media screen and (max-width: 600px) {
  .invalid-report-wrap {
    flex-direction: column;
  }
  .invalid-report-wrap > p {
    padding: 0 0 15px;
    text-align: center;
  }
}
</style>
